import { Vue, Component, Ref, Prop, Provide, Emit } from 'vue-property-decorator'
import ConfigurationAssaysModalBasicForm from '@/modules/configurationModule/detail/assays/configuration-assays/components/configuration-assays-modal-basic-form/configuration-assays-modal-basic-form.vue'
import { BModal } from 'bootstrap-vue'
import { ConfigurationAssayCreateRequest, ConfigurationAssayPatchInBatchRequest, ConfigurationAssayResponse } from '@/modules/configurationModule/detail/assays/configuration-assays/services/configuration-assay/configuration-assay.dto'
import { ConfigurationAssaysModalState, initialConfigurationAssaysModalState } from '@/modules/configurationModule/detail/assays/configuration-assays/components/configuration-assays-modal/configuration-assays-modal.model'

@Component({
    components: {
        ConfigurationAssaysModalBasicForm
    }
})
export default class ConfigurationAssaysModal extends Vue {
    @Ref() readonly configurationAssaysModal!: BModal

    @Prop(String) readonly actionTitle!: string

    @Provide() externalValidator = this.$validator

    @Emit()
    create(): ConfigurationAssayCreateRequest {
        return {
            code: this.state.assay.code!,
            externalId: this.state.assay.externalId!,
            name: this.state.assay.name!,
            active: this.state.assay.active!,
            assaygroupId: this.state.assay.assaygroup!.id,
            subportionTypeId: this.state.assay.subportionType!.sptId,
            isNaa: this.state.assay.isNaa!
        }
    }

    @Emit()
    update(): ConfigurationAssayPatchInBatchRequest {
        return {
            id: this.state.assay.id!,
            code: this.state.assay.code,
            externalId: this.state.assay.externalId ?? undefined,
            name: this.state.assay.name,
            active: !!this.state.assay.active,
            assaygroupId: this.state.assay.assaygroup?.id,
            subportionTypeId: this.state.assay.subportionType?.sptId,
            isNaa: !!this.state.assay.isNaa
        }
    }

    state: ConfigurationAssaysModalState

    private get _updateMode(): boolean {
        return !!this.state.assay?.id
    }

    get modelValidated(): boolean {
        const hasErrors: boolean = this.$validator.errors.any()
        const isDirty: boolean = this.$_someFieldIsDirty(this.fields)
        return !hasErrors && isDirty
    }

    constructor() {
        super()
        this.state = initialConfigurationAssaysModalState()
    }

    async show(assay?: ConfigurationAssayResponse): Promise<void> {
        await this.$validator.reset()

        this.state = initialConfigurationAssaysModalState()
        if (assay) {
            this.state.assay = { ...assay }
        }

        this.configurationAssaysModal.show()
    }

    hide(): void {
        this.configurationAssaysModal.hide()
    }

    async doAction(): Promise<void> {
        const valid = await this.$validator.validateAll()
        if (valid) {
            if (this.state.assay) {
                if (this._updateMode) {
                    this.update() // emits an event
                } else {
                    this.create() // emits an event
                }
            }
        }
    }
}
